import { axios, createFormData, handleError } from '../axios';

export const adminEventSeen = (data) => {
  return new Promise((resolve, reject) => {
    console.log(data);
    console.log(createFormData(data));
    axios
      .post('admin/events/seen/item', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
